// import CustommButton from "../../atoms/button/button";
// import { useLogin } from "./useLogin";
// import logo from "../../../public/IMG_20240704_163245.png";
// import Image from "next/image";
import { useState } from "react";
import logo from "../../Images/SVG 1 1.png"
import loginImage from "../../Images/college entrance exam-pana 1 (1).png"
import axios from "../../axios";
import { toast } from "react-toastify";
import {
  ADMIN_ROLES,
  inferRoleFromEmail,
  storeSessionUser,
} from "../../utils/adminSession";
import { GLOBAL_TENANT_ID } from "../../services/superAdmin/constants";
const Signin = () => {

  const [email,setEmail]=useState("")
  const [password,setPassword]=useState("")
  const [loading, setLoading] = useState(false);

const handleLogin = (e) => {
  e.preventDefault();

  setLoading(true);

  const loginPayload = {
    email,
    password,
  };

  axios
    .post("/adminLogin", loginPayload)
    .then((response) => {
  localStorage.setItem("token", response.data.accessToken);
  const adminPayload =
    response?.data?.result ||
    response?.data?.admin ||
    response?.data?.user ||
    {};
  const resolvedRole =
    adminPayload.role ||
    adminPayload.adminRole ||
    inferRoleFromEmail(adminPayload.email || email) ||
    ADMIN_ROLES.ADMIN;

  storeSessionUser({
    ...adminPayload,
    id: adminPayload._id || adminPayload.id,
    fullName:
      adminPayload.fullName ||
      adminPayload.name ||
      email.split("@")[0] ||
      "Super Admin",
    email: adminPayload.email || email,
    role: resolvedRole,
    status: adminPayload.status || "active",
    assignedTenantId:
      adminPayload.assignedTenantId ||
      adminPayload.tenantId ||
      adminPayload?.tenant?._id ||
      (resolvedRole === ADMIN_ROLES.SUPER_ADMIN ? GLOBAL_TENANT_ID : ""),
  });
  console.log("login successfully")
  toast.success("Login successful");

  setTimeout(() => {
    window.location.replace("/dash");
  }, 1000);
})
    .catch((error) => {
      console.log(error);

      toast.error(
        error?.response?.data?.message || "Invalid email or password"
      );
    })
    .finally(() => {
      setLoading(false);
    });
};

  return (
    <div className="bg-bgBlue">
      <div className="h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full flex items-center  ">
        <div className=" w-1/2 flex justify-center items-center">
          <img src={loginImage} alt="" />
        </div>
        <div className="w-1/2   p-8 bg-bgBlue rounded-xl ">
          <div className="w-full flex flex-col ">
            <div className="self-center text-xl font-semibold flex items-center bg-transparent">
              {/* <span className="mr-1 font-bold text-2xl text-purple">Learn2Ern</span> */}
              {/* <Image src={logo} height={45} width={70} /> */}
              <img src={logo} alt="" className="w-48" />
            </div>
            <p className="mt-2 text-md text-white mt-2">
              Admin Login
            </p>
          </div>

          <form className="w-2/3 m-auto mt-8 space-y-6" method="POST" onSubmit={handleLogin}>
            <div className=" flex flex-col">
              <label className="text-sm font-bold text-purple tracking-wide text-start mb-2">
                Email
              </label>
              <input
                className=" w-full rounded-xl p-2 text-base py-2 border-b border-gray-300 focus:outline-none focus:border-indigo-500"
                name="email"
                placeholder="User Id"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mt-8 text-start flex flex-col">
              <label className="text-sm font-bold text-purple  tracking-wide text-start mb-2">
                Password
              </label>
              <input
                className=" w-full rounded-xl p-2 text-base py-2 border-b border-gray-300 focus:outline-none focus:border-indigo-500"
                type="password"
                placeholder="password"
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
                required
              />
            </div>

          <div className="bg-purple rounded-xl">
  <button
    className="text-white p-2 text-xl font-bold w-full disabled:opacity-50"
    type="submit"
    disabled={loading}
  >
    {loading ? "Logging in..." : "Login"}
  </button>
</div>
          </form>
        </div>
        </div>
       
      </div>
    </div>
  );
};

export default Signin;
